import type { AdTargeting } from '../types'

export function mergeTargeting(current: AdTargeting, incoming: AdTargeting): void {
    const target = current as Record<string, string | undefined>
    for (const key in incoming) {
        const value = incoming[key as keyof AdTargeting]
        if (value) {
            target[key] = value
        } else {
            delete target[key]
        }
    }
}
